import styled from 'styled-components';

const Image = styled.img`
    margin: 0;
    padding: 0;
    max-width: 100%;
    max-height: 100%;
`;

export default Image;



// WEBPACK FOOTER //
// ./src/elements/Image.js